import { useState } from "react"
import CarrierDetailsDefault from "./carrierDetailsDefault"
import CarrierDetailsNB from "./carrierDetailsNB"

interface ICarrierDetailProps {
    enableCarrierDetailsNBView: boolean
}

const CarrierDetails: React.FC<ICarrierDetailProps> = ({ enableCarrierDetailsNBView = false }) => {
    const [showNBView, setShowNBView] = useState(false)

    const changeCarrierDetailsView = () => {
        setShowNBView(prev => !prev)
    }

    if (!enableCarrierDetailsNBView) {
        return <CarrierDetailsDefault />
    }

    return showNBView ?
        <CarrierDetailsNB changeCarrierDetailsView={changeCarrierDetailsView} /> :
        <CarrierDetailsDefault changeCarrierDetailsView={changeCarrierDetailsView} />
}

export default CarrierDetails
